export default __webpack_public_path__ + "static/media/gallery_02.bb8c34d8.jpg";